import { useEffect } from "react";
import { X, LogOut } from "lucide-react";

export default function ConfirmModal({
  open, title, message, confirmLabel = "Yes", cancelLabel = "No",
  onConfirm, onClose, dataTestId = "confirm-modal", confirmDisabled = false,
}) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = prev; window.removeEventListener("keydown", onKey); };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[160] bg-brand-dark/55 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      data-testid={dataTestId}
    >
      <div className="bg-white rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl">
        <div className="px-6 pt-6 pb-3 flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-brand-subtle text-brand-chili flex items-center justify-center">
              <LogOut className="w-5 h-5" strokeWidth={1.6} />
            </span>
            <h3 className="font-serif text-2xl text-brand-dark">{title}</h3>
          </div>
          <button onClick={onClose} aria-label="Close" className="p-1 -mt-1 text-brand-muted active:text-brand-chili">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="px-6 pb-6 text-sm text-brand-muted leading-relaxed">{message}</p>
        <div className="px-6 pb-6 grid grid-cols-2 gap-3">
          <button type="button" onClick={onClose} className="btn-outline !text-sm" data-testid={`${dataTestId}-no`}>
            {cancelLabel}
          </button>
          <button type="button" onClick={onConfirm} disabled={confirmDisabled} className="btn-primary !text-sm disabled:opacity-60" data-testid={`${dataTestId}-yes`}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
